const sloganConfig = [
  '今天应做的事没有做，明天再做也是耽误了。——裴斯泰洛齐',
  '不要看一个人的出身，要看一个人的可能性。——蔡崇达《皮囊》',
  '放弃不难，但坚持一定很酷。——东野奎吾',
  '对未来越有信心，对现在越有信心。——王兴 美团创始人',
  '人生重要的不是所站的位置，而是所朝的方向。——李嘉诚',
  '如果不继续成长，就会开始走向死亡。——华特·迪士尼',
  '这个世界如此美好，值得为它奋战。——海明威',
  '21世纪，没有危机感是最大的危机。',
  '我一定会长大，但我不会长成你们这样的大人。——小王子',
  '等你发现时间是贼了，它早已偷光你的选择，如果认定了，请勇敢的跑下去。——李宗盛',
  '原地踏步还是跑遍世界，选择权在你手里。',
  '每天突破自己的记录，就是一位成功者。',
  '只想逃避困难的人，必然会落后于他人。——阿德勒《自卑与超越》',
  '趁还年轻，为以后的生活再拼拼吧。',
  '未来属于我们当中，那些仍愿意弄脏双手的少数分子。',
  '这个世界很美好，值得为之奋斗。',
  '每一个不曾起舞的日子，都是对生命的的辜负。',
  '只有一件事会让人疲劳，摇摆不定和优柔寡断。——斯蒂芬·茨威格',
  '像个大人一样生存，像个孩子一样生活。——安·兰德《源泉》',
  '成功不是重点，失败也不是灾难，最重要的是要有继续前行的勇气。——丘吉尔',
  '自己被自己打败的，远多于被别人打败的。',
  '这个年纪能做的最好的事，就是努力。',
  '人生在世，要么忙着死，要么忙着活。——《肖胜克的救赎》',
  '不必仰望别人，自己亦是风景。',
  '你就是你，全世界都只是背景。',
  '熬过深夜痛哭，天亮依然铿锵如故。',
  '不要为了天亮去跑，跑下去天自己会亮。',
  '清晨的第一缕阳光，早起才能够看见。',
  '如果你知道去哪，全世界都为你开路。',
  '普通的改变，将改变普通。',
  '每个时代，都悄悄犒赏会学习的人。'
]

export default sloganConfig
